"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var numberFormat_1 = __importDefault(require("../../utils/numberFormat"));
var getCurrencySymbol_1 = __importDefault(require("../../utils/getCurrencySymbol"));
var CarInfoPrice = function (_a) {
    var price = _a.price, discount = _a.discount, oldPrice = _a.oldPrice, currency = _a.currency;
    var acceptableOldPrice = !!oldPrice && !!price && oldPrice > price;
    var labelText = acceptableOldPrice ? 'С учетом выгод' : 'Без учета выгод';
    var currencySymbol = getCurrencySymbol_1.default(currency);
    return (react_1.default.createElement("div", { className: "azgazui__card-price" },
        react_1.default.createElement("div", { className: "azgazui__card-price-label" }, labelText + ":"),
        react_1.default.createElement("div", { className: "azgazui__card-price-full" }, (price && numberFormat_1.default()(price)) + " " + currencySymbol),
        acceptableOldPrice && !!oldPrice && (react_1.default.createElement("div", { className: "azgazui__card-price-old" }, numberFormat_1.default()(oldPrice) + " " + currencySymbol)),
        discount && (react_1.default.createElement("div", { className: "azgazui__card-price-discount" }, discount))));
};
CarInfoPrice.displayName = 'CarInfoPrice';
exports.default = CarInfoPrice;
